export const adminStoreKey = 'admin';
